var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeWithCircle = function SvgHomeWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#f7f9fc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.828 36.57 44.715 26.45a6.675 6.675 0 0 0-9.43 0L25.172 36.57A3.973 3.973 0 0 0 24 39.4v13.098a4.003 4.003 0 0 0 4 4.002h24a3.999 3.999 0 0 0 4-4.002V39.4a3.975 3.975 0 0 0-1.172-2.83ZM44 53.833h-8v-5.249a4.004 4.004 0 0 1 4-4.002 3.998 3.998 0 0 1 4 4.002v5.249Zm9.333-1.334A1.335 1.335 0 0 1 52 53.832h-5.333v-5.249A6.673 6.673 0 0 0 40 41.913a6.673 6.673 0 0 0-6.667 6.67v5.249H28a1.333 1.333 0 0 1-1.333-1.334V39.4c0-.353.141-.692.39-.943L37.171 28.34a4.01 4.01 0 0 1 5.658 0l10.114 10.121c.248.25.388.587.39.94v13.097Z",
    fill: "#1C7CE5"
  })));
};
export default SvgHomeWithCircle;